<app-form-results
    [indexList] = "indexList"
    [systemList] = "systemList"
    [propertiesList] = "propertiesList"
    [propBskList] = "propBskList"
    [groupList]="groupList"
    [userList]="userList"
    (onValidate)="validate($event)"
    (onCancel)="cancel()">
</app-form-results>
